import axios from 'axios';
import { API } from '../constants/api';

const sendApiRequest = async (requestData) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_website_api}${API.broadcast_agent}`, requestData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default sendApiRequest;
